import { render, staticRenderFns } from "./GuidedModeDemographics.vue?vue&type=template&id=a9510bee"
import script from "./GuidedModeDemographics.vue?vue&type=script&lang=ts"
export * from "./GuidedModeDemographics.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports